import { EnvConfig } from '../types';
import { config as configDev } from './dev';

export const config: EnvConfig = {
  ...configDev,
  env: 'local',
};
